import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppActions from 'redux/AppRedux';

function AnonInvitePage() {
  const { venueId, ticketId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (venueId && ticketId) {
      dispatch(AppActions.setInvite({ venueId, ticketId }));
      history.replace('/auth/login');
    }
  }, []);

  return null;
}

export default AnonInvitePage;
